import { defineStore } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

export const useUserActivityStore = defineStore(
  'userActivity',
  () => {
    const timeLoggedIn = ref<number>(0);

    function incrementTimeLoggedIn() {
      timeLoggedIn.value += 1;
    }

    function resetTimeLoggedIn() {
      timeLoggedIn.value = 0;
    }

    const loggedOutByInactivity = ref<boolean>(false);

    function setLoggedOutByInactivity(value: boolean) {
      loggedOutByInactivity.value = value;
    }

    const lastDateSmsSent = ref<string | null>(null);

    function setLastDateSmsSent(value: string | null) {
      lastDateSmsSent.value = value;
    }

    const lastDateEmailSent = ref<string | null>(null);

    function setLastDateEmailSent(value: string | null) {
      lastDateEmailSent.value = value;
    }

    const emailToChange = ref<string | null>(null);

    function setEmailToChange(value: string) {
      emailToChange.value = value;
    }

    function resetEmailToChange() {
      emailToChange.value = null;
    }

    const phoneToChange = ref<{
      phone: string;
      ddi: string;
    } | null>(null);

    function setPhoneToChange(value: { ddi: string; phone: string }) {
      phoneToChange.value = value;
    }

    function resetPhoneToChange() {
      phoneToChange.value = null;
    }

    const isModalPasswordOpen = ref<boolean>(false);

    function setIsModalPasswordOpen(value: boolean) {
      isModalPasswordOpen.value = value;
    }

    function resetIsModalPasswordOpen() {
      isModalPasswordOpen.value = false;
    }

    function $reset() {
      timeLoggedIn.value = 0;
      loggedOutByInactivity.value = false;
      lastDateSmsSent.value = null;
      lastDateEmailSent.value = null;
      isModalPasswordOpen.value = false;
    }

    return {
      timeLoggedIn,
      incrementTimeLoggedIn,
      resetTimeLoggedIn,
      loggedOutByInactivity,
      setLoggedOutByInactivity,
      lastDateSmsSent,
      setLastDateSmsSent,
      lastDateEmailSent,
      setLastDateEmailSent,
      emailToChange,
      setEmailToChange,
      resetEmailToChange,
      phoneToChange,
      setPhoneToChange,
      resetPhoneToChange,
      isModalPasswordOpen,
      setIsModalPasswordOpen,
      resetIsModalPasswordOpen,
      $reset,
    };
  },

  storeConfig,
);
